import React from "react";
import { errorToast } from "./common/showtoast";
import ApiRequest from "./common/restservice";
import PageHeader from "./common/pageheader";

export default class DirectSponsor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: []
    }
  }
  componentDidMount() {
    this.GetDirectSponsors();
  }
  async GetDirectSponsors() {
    let jsoninput = {
      memberid: localStorage.getItem("username")
    };
    let res = await ApiRequest("directsponsorreport.asp", "POST", jsoninput, { Authorization: localStorage.getItem("token") });
    console.log(res);
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Session Expired") {
        localStorage.clear();
        this.props.history.push("/login");
      }
      return;
    }
    this.setState({
      tableData: res.items
    })
  }

  render() {
    return (
      <div>
        <PageHeader title="Direct Sponsor" />
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="card">
              <div className="card-header">
                <h3 className="card-title text-color-1" style={{ fontWeight: "200", fontSize: "22px" }}>
                                    Direct Sponsors List
                </h3>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top" style={{ textAlign: "center" }}>
                    <thead className="">
                      <tr>
                        <th>S.No</th>
                        <th>Name</th>
                        <th>Memberid</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Direct Referral</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        this.state.tableData.length <= 0 ? <tr>
                          <td colSpan="6">No Details Found</td>
                        </tr> :
                          this.state.tableData.map((item, index) => (
                            <tr key={index}>
                              <td className="tabletd">{(index + 1)}</td>
                              <td>{item.fullname}</td>
                              <td>{item.memberid}</td>
                              <td>{item.joindate}</td>
                              <td>{item.status}</td>
                              <td>{item.refferalcount}</td>

                            </tr>
                          ))
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}